import { render, staticRenderFns } from "./ResumeMedisCppt.vue?vue&type=template&id=f4846854&scoped=true"
import script from "./ResumeMedisCppt.vue?vue&type=script&lang=js"
export * from "./ResumeMedisCppt.vue?vue&type=script&lang=js"
import style0 from "./ResumeMedisCppt.vue?vue&type=style&index=0&id=f4846854&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4846854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4846854')) {
      api.createRecord('f4846854', component.options)
    } else {
      api.reload('f4846854', component.options)
    }
    module.hot.accept("./ResumeMedisCppt.vue?vue&type=template&id=f4846854&scoped=true", function () {
      api.rerender('f4846854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/riwayat_pasien/ResumeMedisCppt.vue"
export default component.exports